import { render, staticRenderFns } from "./ContainerSingleExerciseSkeleton.vue?vue&type=template&id=da36a3f8&scoped=true"
import script from "./ContainerSingleExerciseSkeleton.vue?vue&type=script&lang=js"
export * from "./ContainerSingleExerciseSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da36a3f8",
  null
  
)

export default component.exports